import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import api from './api'
import vuetify from './plugins/vuetify'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { Modal } from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'

const app = createApp(App)
app.productionTip = false
app.use(store)
app.use(router)
app.use(vuetify)
app.component('VueModal', Modal)
app.component('VueDatePicker', VueDatePicker)
app.config.globalProperties.$api = api
app.mount('#app')
